import { SurveyLookupParams } from '@ps/survey-utils';

const CRITERIA_SEARCH_KEY: Record<'billingNumber' | 'surveyTitle', string> = {
  billingNumber: 'survey_po',
  surveyTitle: 'tle',
};

export class CriteriaSearchParams {
  private constructor(
    private readonly _searchKey: string,
    private readonly _searchValue: string,
    private readonly _dateRange: readonly Date[] | null | undefined,
    private readonly _countryCode: string | undefined,
    private readonly _languageCode: string | undefined,
  ) {}

  public static forCriteria(
    searchType: 'billingNumber' | 'surveyTitle',
    value: string,
    dateRange: readonly Date[] | null | undefined,
    countryCode: string | undefined,
    languageCode: string | undefined,
  ): CriteriaSearchParams {
    return new CriteriaSearchParams(
      CRITERIA_SEARCH_KEY[searchType],
      value,
      dateRange,
      countryCode,
      languageCode,
    );
  }

  public static forGroup(
    value: string,
    dateRange: readonly Date[] | null | undefined,
    countryCode: string | undefined,
    languageCode: string | undefined,
  ): CriteriaSearchParams {
    return new CriteriaSearchParams(
      'id',
      value,
      dateRange,
      countryCode,
      languageCode,
    );
  }

  public build(): SurveyLookupParams {
    const [fromDate, toDate] = this._dateRange ?? [];

    return {
      fromDate: fromDate ?? null,
      toDate: toDate ?? null,
      searchKey: this._searchKey,
      searchValue: this._searchValue,
      countryCode: this._countryCode,
      languageCode: this._languageCode,
    };
  }
}
